import React from 'react';
import clsx from 'clsx';

export interface SectionShortcutButtonProps {
  /** Tekst wyświetlany na buttonie */
  label: string;
  /** ID elementu DOM, do którego ma nastąpić smooth scroll */
  targetId: string;
  /** Offset (w px) odejmowany od pozycji elementu, np. na sticky header */
  scrollOffset?: number;
  /** Dodatkowe klasy CSS */
  className?: string;
}

export const SectionShortcutButton: React.FC<SectionShortcutButtonProps> = ({
  label,
  targetId,
  scrollOffset = 5,
  className,
}) => {
  const gradientId = `section-shortcut-radial-${targetId}`;

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const element = document.getElementById(targetId);
    if (!element) return;
    const offsetTop =
      element.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      aria-label={`Przejdź do sekcji ${label}`}
      className={clsx(
        'inline-flex self-start items-center gap-4 rounded-full bg-[#fce2ac] py-2 pl-[14px] pr-[26px] transition-colors hover:bg-[#fad391] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#CA9A39]',
        className,
      )}
    >
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 flex-shrink-0"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden="true"
      >
        <circle opacity="0.5" cx={10} cy={10} r={10} fill={`url(#${gradientId})`} />
        <circle cx="10.0002" cy="9.99484" r="7.85714" fill="#CA9A39" />
        <defs>
          <radialGradient
            id={gradientId}
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(10 10) rotate(90) scale(10)"
          >
            <stop offset="0.495225" stopColor="#CA9A39" stopOpacity={0} />
            <stop offset={1} stopColor="#CA9A39" />
          </radialGradient>
        </defs>
      </svg>
      <span className="flex items-center gap-2.5">
        <span className="text-sm font-semibold text-text-primary">{label}</span>
        <svg
          width={12}
          height={11}
          viewBox="0 0 12 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="flex-shrink-0"
          preserveAspectRatio="xMidYMid meet"
          aria-hidden="true"
        >
          <path
            d="M6.21983 10.4437C6.07923 10.3007 6.00024 10.1068 6.00024 9.90457C6.00024 9.70236 6.07923 9.50843 6.21983 9.36542L9.43963 6.09164L0.75001 6.09164C0.551096 6.09164 0.360327 6.0113 0.219673 5.86829C0.0790182 5.72527 5.04698e-07 5.53131 4.87017e-07 5.32906C4.69336e-07 5.12681 0.0790181 4.93284 0.219673 4.78983C0.360327 4.64681 0.551095 4.56647 0.75001 4.56647L9.43963 4.56647L6.21983 1.29269C6.08321 1.14886 6.00762 0.956233 6.00932 0.756285C6.01103 0.556338 6.08991 0.365072 6.22897 0.223682C6.36803 0.0822921 6.55614 0.00209188 6.75279 0.000354272C6.94944 -0.00138334 7.13889 0.0754809 7.28035 0.214392L11.7804 4.78991C11.921 4.93291 12 5.12684 12 5.32905C12 5.53127 11.921 5.7252 11.7804 5.8682L7.28035 10.4437C7.1397 10.5867 6.94897 10.667 6.75009 10.667C6.55121 10.667 6.36048 10.5867 6.21983 10.4437Z"
            fill="#112562"
          />
        </svg>
      </span>
    </a>
  );
};
